import { render, staticRenderFns } from "./EstimatesOldList.vue?vue&type=template&id=8fed491c&"
import script from "./EstimatesOldList.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports